import { render } from "./TranslationMenu.vue?vue&type=template&id=5a4714da&scoped=true"
import script from "./TranslationMenu.vue?vue&type=script&lang=js"
export * from "./TranslationMenu.vue?vue&type=script&lang=js"

import "./TranslationMenu.vue?vue&type=style&index=0&id=5a4714da&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5a4714da"

export default script